

import "./login.scss"
import {useContext, useState} from "react";
import {AuthContext} from "../../context/AuthContext";
import {useNavigate} from "react-router-dom";
import newRequest from "../../context/newRequest";



const Login = () => {
    const [loginFailed, setLoginFailed] = useState("");

    const navigation = useNavigate();
    const [credentials, setCredentials] = useState({
        id: undefined,
        password: undefined,
    });


    const { loading, error, dispatch } = useContext(AuthContext);


    const handleChange = (e) => {
        setCredentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
    };

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const handleClick = async (e) => {
        e.preventDefault();
        dispatch({ type: "LOGIN_START" });
        try {
            const response = await newRequest.post(
                "/users/_login", credentials
            );
            const { data } = response.data;
            if (data.role_id == 1) {
                dispatch({ type: "LOGIN_SUCCESS", payload: data });
                localStorage.setItem("token", data.token);
                navigation("/");
            }else {
                dispatch({
                    type: "LOGIN_FAILURE",
                    payload: { message: "You are not allowed!" },
                });
                setLoginFailed("You are not allowed!")

            }
        } catch (err) {
            console.log(err.response.data.errors);
            setLoginFailed(err.response.data.errors)
            dispatch({ type: "LOGIN_FAILURE", payload: err.response.data.errors});
            await sleep(2000)
            setLoginFailed("")
        }
    };

    return (
        <div className="login">

        <div className="card">
            <div className="left">
                <h1>HelpDesk
                    <br/>
                    Ticket IT
                    <br/>
                    Greenet
                </h1>


            </div>
            <div className="right">
                <h1>Login</h1>

                <form>

                    <input
                        type="text"
                        placeholder="id"
                        id="id"
                        onChange={handleChange}
                        value={credentials.id || ""}
                        className="lInput"
                    />
                    <input
                        type="password"
                        placeholder="password"
                        id="password"
                        onChange={handleChange}
                        value={credentials.password || "" }
                        className="lInput"
                    />
                    <button disabled={loading} onClick={handleClick} className="lButton">
                        Login
                    </button>
                </form>
                {loginFailed && <p className="error">{loginFailed}</p>}
            </div>
        </div>
        </div>

    );
};

export default Login;